import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ClientssoService } from 'src/app/common/services/clientsso.service';

@Component({
  selector: 'app-kantarssocallback',
  templateUrl: './kantarssocallback.component.html',
  styleUrls: ['./kantarssocallback.component.css'],
})
export class KantarssocallbackComponent {
  constructor(
    private authService: ClientssoService,
    private router: Router,
  ) {}

  ngOnInit(): void {
     // Clear session storage to remove any stale tokens or user info
   this.authService.clearStorages();
    this.authService.handleAuthCallback();
  }
}
